// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"163dd5c6","787":"300bbab4","878":"52e2a250"}[chunkId] + ".chunk.js";
};